import { render } from "./IconRenderer.vue?vue&type=template&id=6be5673e&scoped=true"
import script from "./IconRenderer.vue?vue&type=script&lang=js"
export * from "./IconRenderer.vue?vue&type=script&lang=js"

import "./IconRenderer.vue?vue&type=style&index=0&id=6be5673e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be5673e"]])

export default __exports__